import store from '../redux/store'

export const handleCheckAuth = () => {
    const isAuth = store.getState().UserData.userData.token
    return isAuth ? true : false
}